import { RouteRecordRaw } from "vue-router";
import Login from "@/views/user/login-user.vue";
import Register from "@/views/user/create-user.vue";
import Recover from "@/views/user/recover-password.vue";
import EventDescription from "@/components/core/Events/TEventDescription.vue";
import EventMap from "@/components/core/Events/TEventMap.vue";
import TEmailVerification from "@/views/user/email-verification.vue";
import BiometryRegister from "@/views/biometry-register.vue";
import NotFound from "@/components/core/NotFound.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "NotFound",
    components: {
      dialog: NotFound,
    },
  },
  {
    path: "/login",
    name: "Login",
    components: {
      dialog: Login,
    },
  },
  {
    path: "/register",
    name: "Register",
    components: {
      dialog: Register,
    },
  },
  {
    path: "/recover",
    name: "PasswordRecover",
    components: {
      dialog: Recover,
    },
  },
  {
    path: "/event/description",
    name: "EventDescription",
    components: {
      dialog: EventDescription,
    },
  },
  {
    path: "/event/map",
    name: "EventMap",
    components: {
      dialog: EventMap,
    },
  },
  {
    path: "/email/verification",
    name: "EmailVerification",
    components: {
      dialog: TEmailVerification,
    },
  },
  {
    path: "/biometry/register",
    name: "BiometryRegister",
    components: {
      dialog: BiometryRegister,
    },
  },
];

export { routes };
